/**
 * Izdanja Android kase (APK) - ista stranica kao L-PFR izdanja (`ReleasesPage`),
 * sa posledicama koje važe za kasu (`apps/api/src/lib/pos-release.ts`).
 */
import { Pojam } from '../../components/Uputstvo';
import { ReleasesPage, type ReleasesConfig } from './LpfrReleasesPage';

const POS: ReleasesConfig = {
  api: '/admin/pos-releases',
  title: 'Izdanja kase',
  subtitle: 'Objava nove verzije Android kase, kritična i obavezna ažuriranja svih kasa',
  product: 'Efikasa kasa',
  file: 'efikasa-kasa.apk',
  buildCommand: 'npm run release:apk',
  downloadUrl: 'https://api.efikasa.rs/api/pos/app/download',
  testId: 'pos-izdanja',
  noun: { one: 'Kasa', many: 'kasa', title: 'Kase' },
  guideId: 'pos-izdanja',
  guideTitle: 'Kako rade izdanja Android kase - pročitaj pre označavanja kritičnog',
  guide: (
    <>
      <Pojam naziv="Obično izdanje">
        Kasa ga vidi pri pokretanju i na sat vremena, i nudi operateru da ažurira; ponuda može da se odloži.
      </Pojam>
      <Pojam naziv="Kritično">
        Kasa ponudu prikazuje odmah i <strong>ne može da je odloži</strong>. Android uvek traži potvrdu
        instalacije, pa se kasa ne ažurira sama - operater dodirne „Instaliraj".
      </Pojam>
      <Pojam naziv="Obavezno od">
        Posle tog trenutka kasa koja nije ažurirana <strong>ne izdaje račune</strong> - server odbija
        fiskalni poziv dok se ne ažurira. Rok uvek povlači i „kritično".
      </Pojam>
      <Pojam naziv="Povučeno">
        Izdanje se više ne nudi i ne preuzima. Kase koje su ga već instalirale ostaju na njemu.
      </Pojam>
      <Pojam naziv="Build">
        Build je <code>versionCode</code> APK-a. Android ne instalira niži preko višeg, pa ga server odbija.
        APK mora biti potpisan istim ključem kao instalirani - inače se ažuriranje ne može instalirati.
      </Pojam>
    </>
  ),
  criticalWarning: (build) => (
    <>
      Svaka kasa ispod build-a {build}, kod svih firmi, prikazaće ponudu ažuriranja <strong>odmah i bez
      mogućnosti odlaganja</strong>. Instalaciju i dalje potvrđuje operater (Android to traži).
    </>
  ),
  mandatoryWarning: (build) => (
    <>
      Posle izabranog trenutka kasa koja nije ažurirana na build {build} ili noviji
      <strong> NE IZDAJE RAČUNE</strong>, kod svih firmi - server odbija fiskalni poziv. Izdanje postaje i
      kritično. Kasa koja je ugašena do roka ostaje bez izdavanja dok se ne ažurira.
    </>
  ),
  releaseCritical: <>release.json označava izdanje kao <strong>kritično</strong> - kase ponudu prikazuju odmah, bez odlaganja.</>,
  releaseMandatory: (rok) => <>release.json traži <strong>obavezno ažuriranje od {rok}</strong> - posle toga neažurirana kasa ne izdaje račune.</>,
  publishedHint: 'kase ga vide pri sledećoj proveri (pokretanje ili na sat vremena)',
};

export function PosReleasesPage() {
  return <ReleasesPage cfg={POS} />;
}
